export default __webpack_public_path__ + "static/media/default.8af672fd.svg";